import { useState } from "react"
import { Link } from "react-router-dom"

const MobileMenu = ({}) => {
	const [showMenu, setShowMenu] = useState<boolean>(false)

	return (
		<>
			<img src="/images/menu.png" alt="" className="absolute cursor-pointer right-4 top-4  w-[48px] h-[48px] z-[100]" onClick={() => setShowMenu(true)} />
			{showMenu && (
				<div className="fixed top-0 left-0 z-[800] h-[100vh] w-[100vw] items-center bg-green text-center ">
					<div className="relative flex h-[100vh] items-center align-middle">
						<img
							src={"/images/btn-close.png"}
							alt="Menu"
							loading="lazy"
							width="83"
							height="73"
							className=" absolute top-9 right-9 w-[35px] cursor-pointer"
							onClick={() => setShowMenu(false)}
						/>
						<ul className="mx-auto">
							<li className="my-4">
								<a
									href={process.env.PUBLIC_URL + "/#form"}
									className="header-item-mobile"
									onClick={() => {
										try {
											// eslint-disable-next-line
											let dataLayer = window["dataLayer"] || []
											dataLayer.push({ event: "header", link: "teilnahmebedingungen" })
										} catch (e) {}
										return setShowMenu(false)
									}}
								>
									Jetzt teilnehmen
								</a>
							</li>
							<li className="my-4">
								<Link
									to={process.env.PUBLIC_URL + "/faq"}
									className="header-item-mobile"
									onClick={() => {
										try {
											// eslint-disable-next-line
											let dataLayer = window["dataLayer"] || []
											dataLayer.push({ event: "header", link: "faq" })
										} catch (e) {}
										return setShowMenu(false)
									}}
								>
									FAQS
								</Link>
							</li>
							<li className="my-4">
								<Link
									to={process.env.PUBLIC_URL + "/teilnahmebedingungen"}
									className="header-item-mobile"
									onClick={() => {
										try {
											// eslint-disable-next-line
											let dataLayer = window["dataLayer"] || []
											dataLayer.push({ event: "header", link: "kontakt" })
										} catch (e) {}
										return setShowMenu(false)
									}}
								>
									Teilnahmebedingungen
								</Link>
							</li>
							<li className="my-4">
								<Link
									to={process.env.PUBLIC_URL + "/kontakt"}
									className="header-item-mobile"
									onClick={() => {
										try {
											// eslint-disable-next-line
											let dataLayer = window["dataLayer"] || []
											dataLayer.push({ event: "header", link: "kontakt" })
										} catch (e) {}
										return setShowMenu(false)
									}}
								>
									Kontakt
								</Link>
							</li>
						</ul>
					</div>
				</div>
			)}
		</>
	)
}

export default MobileMenu
